<template>
  <div class="legislation-lp__container">
    <v-navigation-drawer v-model="isMenuOpen" app temporary width="80%">
      <a class="close-menu" @click="showMenu">close menu</a>
      <ul>
        <li v-for="(item, i) in $t('legislationLP.menu')" :key="i">
          <a
            :target="item.external === true ? '_blank' : '_self'"
            :title="item.title"
            :href="item.disabled !== true ? item.url : ''"
            :class="{
              'btn-disabled': item.disabled === true,
            }"
            >{{ item.title }}</a
          >
        </li>
      </ul>
    </v-navigation-drawer>
    <header>
      <router-link to="/">
        <picture class="logo">
          <source
            media="(max-width: 959px)"
            srcset="@/assets/images/logo-eureciclo-mobile1.png"
          />
          <source
            media="(min-width: 960px)"
            srcset="@/assets/images/logo-eureciclo-desktop.png"
          />
          <img
            src="@/assets/images/logo-eureciclo-desktop.png"
            alt="eureciclo"
          />
        </picture>
      </router-link>
      <!-- <div class="translate-wrapper">
        <a
          v-if="languageSelected === 'br'"
          title="Translate to English"
          class="english"
          @click="setTranslate('en')"
          >Translate to English</a
        >
        <a
          v-else
          title="Traduzir para Português"
          class="portuguese"
          @click="setTranslate('br')"
          >Traduzir para Português</a
        >
      </div> -->
      <v-img
        v-if="$vuetify.breakpoint.smAndDown"
        contain
        max-width="27"
        :src="require('@/assets/images/legislation-lp/menu.png')"
        @click="showMenu"
      />
    </header>
    <div class="legislation-lp__content">
      <div
        id="hero-section-anchor"
        class="legislation-lp__content--heroSection"
      >
        <v-container fluid class="pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" class="pa-0">
              <h2 v-html="$t('legislationLP.heroSection.title')"></h2>
              <p v-html="$t('legislationLP.heroSection.content')"></p>
              <a
                :target="
                  $t('legislationLP.heroSection.button.external') === true
                    ? '_blank'
                    : '_self'
                "
                :title="$t('legislationLP.heroSection.button.title')"
                :href="$t('legislationLP.heroSection.button.url')"
                class="button"
                v-html="$t('legislationLP.heroSection.button.title')"
              >
              </a>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div
        id="highlights-section-anchor"
        class="legislation-lp__content--highlightsSection"
      >
        <v-container fluid class="pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" class="pa-0">
              <h2 v-html="$t('legislationLP.highlightsSection.title')"></h2>
            </v-col>
          </v-row>
        </v-container>
        <VueSlickCarousel v-bind="highlightsSectionSettings">
          <div
            v-for="(carousel, i) in $t(
              'legislationLP.highlightsSection.carousel',
            )"
            :key="i"
          >
            <v-container fluid class="pa-0">
              <v-row class="ma-0 pa-0 content-wrapper">
                <v-col cols="12" md="7" xl="9" class="text-wrapper">
                  <p v-html="carousel.content"></p>
                </v-col>
                <v-col cols="12" md="5" xl="3" class="image-wrapper">
                  <v-img
                    contain
                    :src="
                      require('@/assets/images/legislation-lp/' +
                        carousel.image)
                    "
                  />
                </v-col>
              </v-row>
            </v-container>
          </div>
        </VueSlickCarousel>
      </div>
      <div
        id="benefits-section-anchor"
        class="legislation-lp__content--benefitsSection"
      >
        <v-container fluid class="pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" md="11" offset-md="1" class="pa-0">
              <h2 v-html="$t('legislationLP.benefitsSection.title')"></h2>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col
              cols="12"
              md="8"
              offset-md="4"
              lg="6"
              offset-lg="6"
              xl="5"
              offset-xl="7"
              class="pa-0"
            >
              <v-row class="ma-0 pa-0">
                <v-col
                  v-for="(card, i) in $t('legislationLP.benefitsSection.cards')"
                  :key="i"
                  cols="12"
                  md="6"
                  class="card-wrapper"
                >
                  <div class="card">
                    <v-img
                      contain
                      :src="
                        require('@/assets/images/legislation-lp/' + card.image)
                      "
                      :width="i === 2 ? '100px' : '66px'"
                    />
                    <p v-html="card.content"></p>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div
        id="doubt-section-anchor"
        class="legislation-lp__content--doubtSection"
      >
        <i class="icon-box">&nbsp;</i>
        <v-container fluid class="pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" class="pa-0">
              <h2 v-html="$t('legislationLP.doubtSection.title')"></h2>
              <h4 v-html="$t('legislationLP.doubtSection.subtitle')"></h4>
              <LegislationLpContactForm />
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div
        id="video-section-anchor"
        class="legislation-lp__content--videoSection"
      >
        <v-container fluid class="pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" class="pa-0">
              <h2 v-html="$t('legislationLP.videoSection.title')"></h2>
            </v-col>
            <v-col cols="12" class="pa-0 text-center">
              <youtube
                :player-width="video.width"
                :player-height="video.height"
                :video-id="video.videoId"
              />
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div
        id="partners-section-anchor"
        class="legislation-lp__content--partnersSection"
      >
        <v-container fluid class="pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" class="pa-0">
              <h2 v-html="$t('legislationLP.partnersSection.title')"></h2>
            </v-col>
            <v-col
              class="pa-0 px-10 partners-carousel-wrapper"
              cols="12"
              align="center"
            >
              <VueSlickCarousel v-bind="partnersSectionSettings">
                <div
                  v-for="(carousel, i) in $t(
                    'legislationLP.partnersSection.carousel',
                  )"
                  :key="i"
                >
                  <v-img
                    contain
                    height="115px"
                    width="115px"
                    class="partners-logo"
                    :position="
                      !$vuetify.breakpoint.mobile
                        ? 'center top'
                        : 'center center'
                    "
                    :src="require('@/assets/images/brands/' + carousel.image)"
                  />
                </div>
                <template #prevArrow>
                  <div class="custom-arrow">
                    <v-icon> mdi-chevron-left </v-icon>
                  </div>
                </template>
                <template #nextArrow>
                  <div class="custom-arrow">
                    <v-icon> mdi-chevron-right </v-icon>
                  </div>
                </template>
              </VueSlickCarousel>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div
        id="statistics-section-anchor"
        class="legislation-lp__content--statisticsSection"
      >
        <v-container fluid class="pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" class="pa-0">
              <h2 v-html="$t('legislationLP.statisticsSection.title')"></h2>
            </v-col>
          </v-row>
          <v-row class="pa-0 cards-wrapper">
            <v-col
              v-for="(card, i) in $t('legislationLP.statisticsSection.cards')"
              :key="i"
              cols="12"
              md="3"
              offset-md="1"
              class="card"
            >
              <v-img
                contain
                :src="require('@/assets/images/legislation-lp/' + card.image)"
                :width="i === 0 ? '90px' : i === 1 ? '115px' : '76px'"
              />
              <div class="text-wrapper">
                <h3 v-html="card.title"></h3>
                <p v-html="card.content"></p>
              </div>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-col cols="12" class="pa-0 text-center">
              <a
                :target="
                  $t('legislationLP.statisticsSection.button.external') === true
                    ? '_blank'
                    : '_self'
                "
                :title="$t('legislationLP.statisticsSection.button.title')"
                :href="$t('legislationLP.statisticsSection.button.url')"
                class="button"
                v-html="$t('legislationLP.statisticsSection.button.title')"
              >
              </a>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div id="faq-section-anchor" class="legislation-lp__content--faqSection">
        <v-container fluid class="pa-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="12" class="pa-0">
              <h2 v-html="$t('legislationLP.faqSection.title')"></h2>
              <v-expansion-panels>
                <v-expansion-panel
                  v-for="(question, i) in $t(
                    'legislationLP.faqSection.questions',
                  )"
                  :key="i"
                >
                  <v-expansion-panel-header>
                    <h3 class="title-question" v-html="question.question"></h3>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <p class="answer-question" v-html="question.answer"></p>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <footer>
      <v-container fluid class="pa-0">
        <v-row class="ma-0 pa-0 align-center justify-center">
          <v-col cols="12" class="pa-0">
            <ul>
              <li
                v-for="(logo, i) in $t('legislationLP.footer.logos')"
                :key="i"
              >
                <v-img
                  contain
                  :src="require('@/assets/images/legislation-lp/' + logo.image)"
                />
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </footer>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';

export default {
  name: 'LegislationLp',
  metaInfo: {
    title: 'Legislação - LP',
  },
  components: {
    VueSlickCarousel,
    LegislationLpContactForm: () =>
      import('@/components/Forms/LegislationLpContactForm.vue'),
  },
  data: () => ({
    mdiChevronLeft,
    mdiChevronRight,
    highlightsSectionSettings: {
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      arrows: false,
      dots: true,
      dotsClass: 'slick-dots highlights-dots',
      fade: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            swipe: true,
          },
        },
      ],
    },
    partnersSectionSettings: {
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            swipe: true,
          },
        },
      ],
    },
    video: {
      videoId: 'P2ioFOuYsK0',
      width: '640',
      height: '360',
    },
    isMenuOpen: false,
    languageSelected: 'br',
  }),
  mounted() {
    if (window.innerWidth < 600) {
      this.video.width = '320';
      this.video.height = '180';
    } else if (window.innerWidth > 1264) {
      this.video.width = '640';
      this.video.height = '360';
    }
  },
  methods: {
    setTranslate(language) {
      this.languageSelected = language;
      this.$i18n.locale = language;
    },
    showMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.legislation-lp
  &__container
    @media screen and (max-width: 959px)
      overflow: hidden
    .v-navigation-drawer
      @media screen and (max-width: 959px)
        .close-menu
          background: url("~@/assets/images/performance-report/icon_close.png") no-repeat right center
          position: relative
          display: block
          height: 30px
          padding: 10px 20px 0 0
          margin-bottom: 40px
          margin-right: 20px
          margin-top: 20px
          text-indent: -999999px
          text-decoration: none
          outline: none
        ul
          list-style-type: none
          li
            position: relative
            display: block
            &:not(:last-child)
              padding: 0 0 20px 0
              margin: 0 0 20px 0
              &:after
                background: #003036
                content: ''
                position: absolute
                display: block
                width: 70%
                height: 1px
                opacity: .1
                bottom: 0
                left: 0
            a
              position: relative
              display: block
              width: 100%
              height: 100%
              font-family: 'metropolissemi_bold' !important
              font-weight: normal !important
              font-size: 23px
              line-height: 1
              color: #26D07C
              text-decoration: none
              outline: none
              transition: all 300ms ease-in-out
              &:hover
                color: #003036
                transition: all 300ms ease-in-out
    header
      min-height: 63px
      background: #ffffff
      padding: 0 80px
      display: flex
      justify-content: space-between
      align-items: center
      .logo
        max-height: 40px
      .translate-wrapper
        a
          position: relative
          display: block
          width: 27px
          height: 27px
          outline: none
          border: 0
          text-indent: -9999px
          &.english
            background: url("~@/assets/images/performance-report/icon-english.png") no-repeat
          &.portuguese
            background: url("~@/assets/images/performance-report/icon-brazil.png") no-repeat
    @media screen and (max-width: 959px)
      header
        padding: 0 30px
    footer
      background: #00031C
      padding: 40px 0
      border-top: 1px solid #26D07C
      ul
        position: relative
        display: flex
        align-items: center
        justify-content: center
        text-align: center
        padding: 0
        list-style-type: none
        li
          margin: 0 20px
          .v-image
            max-width: 100px
            max-height: 100px
      @media screen and (max-width: 959px)
        padding: 40px 0 0
        ul
          flex-wrap: wrap
          li
            margin: 0 30px 40px
  &__content
    &--heroSection,
    &--highlightsSection,
    &--benefitsSection,
    &--doubtSection,
    &--videoSection,
    &--partnersSection,
    &--statisticsSection,
    &--faqSection
      overflow: hidden
      position: relative
      h2,
      h4,
      p
        ::v-deep span,
        ::v-deep b
          font-family: 'metropolisbold' !important
      h2
        font-family: 'metropolissemi_bold' !important
        font-weight: normal !important
        font-size: 48px
        line-height: 1
        color: #ffffff
        padding: 0
        margin: 0
        text-align: left
      p
        font-family: 'metropolisregular' !important
        font-weight: normal !important
        font-size: 18px
        line-height: 1.3
        color: #ffffff
        padding: 0
        margin: 0
        text-align: left
      .button
        background: #ffffff
        position: relative
        display: block
        color: #00031C
        font-family: 'metropolissemi_bold' !important
        font-weight: normal !important
        font-size: 24px
        text-align: center
        line-height: 1
        padding: 25px 30px
        border-radius: 10px
        outline: none
        text-decoration: none
        transition: all 300ms ease-in-out
        cursor: pointer
        z-index: 1
        &:hover
          background: #00031C
          color: #ffffff
          transition: all 300ms ease-in-out
      @media screen and (max-width: 959px)
        h2
          font-size: 32px
          line-height: 1.5
        p
          font-size: 16px
        .button
          line-height: 1.3
    &--heroSection
      background: #147BD1
      padding: 100px 80px 60px
      &:before,
      &:after
        content: ''
        position: absolute
        display: block
      &:before
        background: url("~@/assets/images/legislation-lp/herosection-bg01.png") no-repeat
        width: 403px
        height: 106px
        bottom: 60px
        right: -4%
      &:after
        background: url("~@/assets/images/legislation-lp/herosection-bg02.png") no-repeat
        width: 794px
        height: 1340px
        bottom: -10%
        right: -28%
      h2
        max-width: 860px
        margin-bottom: 50px
      p
        max-width: 720px
        margin-bottom: 60px
      .button
        max-width: 530px
        background: #f56842
        color: #ffffff
        &:hover
          background: #ffffff
          color: #f56842
      @media screen and (max-width: 959px)
        padding: 50px 40px 60px
        &:before
          background: url("~@/assets/images/legislation-lp/herosection-bg01-mobile.png") no-repeat
          width: 115px
          height: 196px
          right: 0
          transform: translate(50%, 0)
        &:after
          background: url("~@/assets/images/legislation-lp/herosection-bg02-mobile.png") no-repeat
          width: 678px
          height: 1142px
          right: -120%
          bottom: 25%
        p
          max-width: 255px
      @media screen and (max-width: 500px)
        .button
          max-width: 275px
          text-align: left
      @media screen and (min-width: 320px) and (max-width: 359px)
        &:after
          right: -137%
          bottom: 50%
          transform: rotate(-15deg)
      @media screen and (min-width: 360px) and (max-width: 362px)
        &:after
          right: -128%
          bottom: 34%
          transform: rotate(-12deg)
      @media screen and (min-width: 363px) and (max-width: 374px)
        &:after
          right: -137%
          bottom: 50%
          transform: rotate(-15deg)
      @media screen and (min-width: 375px) and (max-width: 389px)
        &:after
          right: -114%
          bottom: 25%
          transform: rotate(-18deg)
      @media screen and (min-width: 390px) and (max-width: 409px)
        &:after
          right: -117%
          transform: rotate(-12deg)
      @media screen and (min-width: 410px) and (max-width: 413px)
        &:after
          right: -108%
          transform: rotate(-12deg)
      @media screen and (min-width: 414px) and (max-width: 424px)
        &:after
          right: -123%
          transform: rotate(0deg)
      @media screen and (min-width: 2080px)
        &:after
          right: -20%
    &--highlightsSection
      background: #ffffff
      padding: 40px 80px
      h2, p
        color: #00031C
      .content-wrapper
        .text-wrapper
          padding-left: 0
          h2
            line-height: 1.2
            margin-bottom: 80px
          p
            max-width: 570px
        .image-wrapper
          margin: 0
      @media screen and (max-width: 959px)
        padding: 70px 40px
        p
          font-size: 18px
        .content-wrapper
          display: flex
          flex-flow: column-reverse
          padding-top: 90px !important
          .image-wrapper
            margin-bottom: 40px
      @media screen and (min-width: 960px)
        h2
          position: absolute
          display: block
          top: 40px
          left: 80px
        .content-wrapper
          .text-wrapper
            padding-top: 180px
    &--benefitsSection
      background: #28D07D
      padding: 115px 50px 70px 0
      &:before
        background: url("~@/assets/images/legislation-lp/benefitssection-bg01.png") no-repeat
        background-size: 80%
        content: ''
        position: absolute
        display: block
        width: 962px
        height: 729px
        top: 50%
        left: -25%
        transform: translate(0, -50%)
        z-index: 0
      h2, p
        color: #00031C
      h2
        text-align: right
        margin-bottom: 50px
      .card-wrapper
        z-index: 1
        &:nth-child(3)
          .card
            .v-image
              margin-left: -22px
        .card
          background: #ffffff
          border-radius: 24px
          padding: 35px
          min-height: 310px
          .v-image
            margin-bottom: 40px
      @media screen and (min-width: 960px) and (max-width: 1660px)
        .card-wrapper
          .card
            min-height: 395px
      @media screen and (max-width: 1249px)
        &:before
          background-size: 72%
          height: 659px
      @media screen and (max-width: 1080px)
        &:before
          background-size: 60%
          height: 545px
      @media screen and (max-width: 959px)
        padding: 70px 40px
        &:before
          display: none
        h2
          text-align: left
        .card-wrapper
          &:not(:last-child)
            margin-bottom: 20px
          .card
            min-height: auto
      @media screen and (min-width: 1920px)
        &:before
          left: -15%
    &--doubtSection
      background: #F56842
      padding: 90px 0 70px
      &:before,
      &:after,
      .icon-box
        content: ''
        position: absolute
        display: block
        z-index: 0
      &:before
        background: url("~@/assets/images/legislation-lp/doubtsection-bg01.png") no-repeat
        width: 544px
        height: 503px
        top: 50%
        left: 0
        transform: translate(-50%, -50%)
      &:after
        background: url("~@/assets/images/legislation-lp/doubtsection-bg02.png") no-repeat
        width: 180px
        height: 180px
        bottom: 0
        right: 0
      .icon-box
        background: url("~@/assets/images/legislation-lp/doubtsection-bg03.png") no-repeat
        width: 259px
        height: 230px
        top: 20%
        right: 2%
      h2,
      h4
        color: #ffffff
        text-align: center
      h2
        margin-bottom: 20px
      h4
        font-family: 'metropolisregular' !important
        font-weight: normal !important
        font-size: 32px
        line-height: 1
        padding: 0
        margin: 0 auto 50px
        max-width: 800px
      @media screen and (max-width: 959px)
        padding: 90px 40px 70px
        &:before,
        &:after,
        .icon-box
          display: none
        h2,
        h4
          text-align: left
    &--videoSection
      background: #ffffff
      padding: 90px 0
      .container
        position: relative
        z-index: 1
      &:before,
      &:after
        content: ''
        position: absolute
        display: block
        z-index: 0
      &:before
        background: url("~@/assets/images/legislation-lp/videosection-bg02.png") no-repeat
        width: 1977px
        height: 827px
        bottom: -48%
        left: -115%
      &:after
        background: url("~@/assets/images/legislation-lp/videosection-bg01.png") no-repeat
        width: 180px
        height: 180px
        top: 0
        right: 0
      h2
        color: #00031C
        text-align: center
        margin: 0 auto 60px
        max-width: 880px
      @media screen and (min-width: 1440px)
        &:before
          left: -97%
      @media screen and (min-width: 1720px)
        &:before
          left: -73%
      @media screen and (min-width: 1920px)
        &:before
          left: -55%
          bottom: -51%
      @media screen and (max-width: 959px)
        padding: 90px 0
        &:before,
        &:after
          display: none
        h2
          text-align: left
          padding: 0 40px
    &--partnersSection
      background: #6F7BD4
      padding: 100px 0
      h2
        max-width: 920px
        text-align: center
        margin: 0 auto 90px
        ::v-deep span
          color: #ECF166
      .partners-carousel-wrapper
        background: #ffffff
        min-height: 200px
        padding-top: 50px !important
        .custom-arrow
          width: 40px
          height: 40px
          &:before
            display: none
          .v-icon
            font-size: 40px
            color: #000
            opacity: 0.15
          &:hover
            .v-icon
              opacity: 1
      @media screen and (max-width: 959px)
        padding: 90px 40px
        h2
          text-align: left
        .partners-carousel-wrapper
          padding-top: 40px !important
          border-radius: 28px
    &--statisticsSection
      background: #ffffff
      padding: 80px 0 100px
      h2
        color: #00031C
        text-align: center
        margin: 0 auto 60px
        max-width: 880px
        line-height: 1.2
      .cards-wrapper
        margin: 0 0 80px 0
        .card
          display: flex
          flex-flow: column
          justify-content: center
          align-items: flex-start
          .v-image
            margin-bottom: 30px
          h3
            font-family: 'metropolisbold' !important
            font-weight: normal !important
            font-size: 32px
            line-height: 1
            color: #26D07C
            text-align: left
            margin-bottom: 10px
          p
            color: #00031C
            line-height: 1.5
            max-width: 240px
          &:last-child
            p
              max-width: 280px
      .button
        background: #F4633A
        color: #ffffff
        display: inline-block
        border: 2px solid transparent
        &:hover
          background: transparent
          color: #F4633A
          border: 2px solid #F4633A
      @media screen and (max-width: 959px)
        padding: 90px 40px
        h2
          text-align: left
          font-size: 28px
        .cards-wrapper
          .card
            &:not(:last-child)
              margin-bottom: 40px
            h3
              font-size: 28px
    &--faqSection
      background: #00031C
      padding: 100px
      h2
        color: #26D07C
        margin-bottom: 30px
      .v-expansion-panels
        .v-expansion-panel
          background: transparent
          .v-expansion-panel-header
            padding-left: 0
            h3
              color: #ffffff
              font-size: 24px
            ::v-deep span
              color: #26D07C
          .v-expansion-panel-content
            p
              color: #ffffff
              font-size: 18px
              padding-left: 10px
      @media screen and (max-width: 959px)
        padding: 90px 0px 90px 40px
        .v-expansion-panels
          .v-expansion-panel
            .v-expansion-panel-header
              h3
                font-size: 18px
                line-height: 1.5
            .v-expansion-panel-content
              ::v-deep
                .v-expansion-panel-content__wrap
                  padding: 0
              p
                padding: 0
::v-deep
  .slick-dots li
    width: auto
    height: auto
  .slick-dots li button
    width: 30px
    height: 30px
    border-radius: 50%
    font-size: 18px
    line-height: 1
    color: #00031C
    border: 1px solid #00031C
    opacity: 1
  .slick-dots li.slick-active button
    background: #00031C
    color: #ffffff
  .slick-dots li button:before
    display: none
  .slick-dots.highlights-dots
    bottom: inherit
    top: 27%
    text-align: left
    padding: 0
    @media screen and (max-width: 959px)
      top: 35%
    @media screen and (max-width: 959px)
      top: 6%
</style>
